export const getRouterDirection = (oldPath: string, newPath: string) => {
  const oldGroups = /\/event-scores\/[0-9]+\/round\/[0-9]+\/hole\/([0-9\-]+)/g.exec(oldPath);
  const oldPage = oldGroups && oldGroups.length > 1 ? oldGroups[1] : 0;
  const newGroups = /\/event-scores\/[0-9]+\/round\/[0-9]+\/hole\/([0-9\-]+)/g.exec(newPath);
  const newPage = newGroups && newGroups.length > 1 ? newGroups[1] : 0;

  return Number(newPage) < Number(oldPage) ? 'reverse' : '';
};
